module.exports = __webpack_public_path__ + "img/t3-i1.9812b06d.svg";